import type {ReasonOption} from '../cancel/types';

export const CHURN_FORM_ANIMATION_SRC = '/include/rive/billing-churn/potted-plant.riv';
export const CHURN_FORM_SUBMITTED_ANIMATION_SRC = '/include/rive/billing-churn/sun.riv';

export type ReasonCategory = {
    title: string;
    options: ReasonOption[];
};

// twins for reason values live in /library/Nut/ChurnInfo.php
export const churnReasonCategories: ReasonCategory[] = [
    {
        title: 'Usage-Related',
        options: [
            {value: 'My team had trouble adopting Nutshell'},
            {value: 'Our team has gotten smaller, so we don’t need as many users'},
            {value: 'One department or team no longer needs access'},
            {value: 'Our Nutshell usage is seasonal or temporary'},
        ],
    },
    {
        title: 'Pricing and Value',
        options: [
            {value: 'We’re consolidating software tools'},
            {value: 'We’re reducing overall software costs'},
            {value: 'We’re moving to a plan that better fits our current needs'},
            {value: 'Part of our workflow has moved to another platform'},
            {value: 'We’re not getting enough value from our current plan'},
        ],
    },
    {
        title: 'Business or Personal Changes',
        options: [
            {value: 'Our company has merged, been acquired, or restructured'},
            {value: 'We plan to move away from Nutshell completely in the near future'},
            {value: 'Our business model or sales process has changed'},
        ],
    },
];
